module.exports = __webpack_public_path__ + "img/icoon_elementen_small.71802b09.svg";